import React, { useContext } from "react";
import Dashboard from "../dashboard/Dashboard";
import Login from "../user-forms/Login";
import Register from "../user-forms/Register";
import { Navigate, Route, Routes } from "react-router-dom";
import NoPageFound from "../NoPageFound";
import { AuthContext } from "../../context/AuthContext";
import Test from "../../Test";
import UserList from "../users/UserList";
import Cards from "../cards/Cards";
import UserDetails from "../users/UserDetails";
import InvoiceList from "../billing/InvoiceList";
import Projects from "../projects/Projects";
 
function PrivateRoute({ children }) {
  const { admin_panel_user } = useContext(AuthContext);

  return admin_panel_user.token ? children : <Navigate to="/" />;
}
function RedirectToHome({ children }) {
  const { admin_panel_user } = useContext(AuthContext);

  return !admin_panel_user.token ? children : <Navigate to="/dashboard" />;
}
const Navigation = ({toggleTheme}) => {
  return (
    <div>
      {" "}
      <Routes>
        <Route
          path="/"
          element={
            <RedirectToHome>
              {" "}
              <Login />{" "}
            </RedirectToHome>
          }
        />
        <Route
          path="/register"
          element={
            <RedirectToHome>
              <Register />
            </RedirectToHome>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard toggleTheme={toggleTheme}/>
            </PrivateRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <PrivateRoute>
              <InvoiceList />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-list"
          element={
            <PrivateRoute>
              <UserList />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-details/:id"
          element={
            <PrivateRoute>
              <UserDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/cards"
          element={
            <PrivateRoute>
              <Cards />
            </PrivateRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Projects />
            </PrivateRoute>
          }
        />

        <Route path="*" element={<NoPageFound />} />

        <Route path="/test" element={<Test />} />
      </Routes>
    </div>
  );
};

export default Navigation;
